import { render, staticRenderFns } from "./play.vue?vue&type=template&id=4c1fa50c&scoped=true"
import script from "./play.vue?vue&type=script&lang=js"
export * from "./play.vue?vue&type=script&lang=js"
import style0 from "./play.vue?vue&type=style&index=0&id=4c1fa50c&prod&lang=css"
import style1 from "./play.vue?vue&type=style&index=1&id=4c1fa50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1fa50c",
  null
  
)

export default component.exports